// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__1DT0U","content":"Container_content__18R0j"};